import { Effect } from 'effect';

import { reactivityKeys } from '../reactivityKeys';
import { createFavouriteList } from '../../flow/favourites/createFavouriteListWithProduct';
import { RuntimeClientAtom } from '../../runtime/RuntimeClient';

export const createFavouriteListAtomFn = RuntimeClientAtom.fn(
  Effect.fnUntraced(function* (params: { name: string }) {
    return yield* createFavouriteList(params.name);
  }),
  {
    reactivityKeys: [reactivityKeys.favouriteLists],
  }
);
